import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useNavigate } from "react-router-dom";
import { init } from "ityped";
import axios from 'axios';
import { API_BASE_URL, ACCESS_TOKEN_NAME, Image_Base_Url, ACCESS_Role_ID, ACCESS_Log_In_User_Id } from '../constants/apiConstants';
import Modal from '../components/Modal';  // Import Modal component
import PdExam from '../components/pdExam';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';

import heroImage from '../../src/assets/images/all/image2q.png';
import searchIcon from '../../src/assets/images/all/search.svg';
import with_pad from '../../src/assets/images/all/with_pad.png';
import teacher1 from '../../src/assets/images/all/teacher_1.png';
import teacher2 from '../../src/assets/images/all/teacher_2.png';
import teacher3 from '../../src/assets/images/all/teacher_3.png';
import teacher4 from '../../src/assets/images/all/teacher_4.png';
import videoImage from '../../src/assets/images/all/abdaal.jpg';
import shape1 from '../../src/assets/images/all/shape_2.png';
import shape2 from '../../src/assets/images/all/shape_3.png';
import shape3 from '../../src/assets/images/all/shape_4.png';
import shape4 from '../../src/assets/images/all/shape_5.png';
import brand1 from '../../src/assets/images/all/brand_1.png';
import brand2 from '../../src/assets/images/all/brand_2.png';
import brand3 from '../../src/assets/images/all/brand_3.png';
import brand4 from '../../src/assets/images/all/brand_4.png';
import brand5 from '../../src/assets/images/all/brand_5.png';
import brand6 from '../../src/assets/images/all/brand_6.png';
import blog1 from '../../src/assets/images/all/blog.png';
import blog2 from '../../src/assets/images/all/blog_2.png';
import backgroundBanner1 from "../assets/img/logo/element1.png";
import backgroundBanner2 from "../assets/img/logo/element2.png";
import bannerIcon1 from "../assets/img/logo/banner-icon1.png";
import bannerIcon2 from "../assets/img/logo/banner-icon2.png";
import bannerIcon3 from "../assets/img/logo/banner-icon3.png";
import bannerIcon4 from "../assets/img/logo/banner-icon4.png";
import addImg from "../assets/img/add/add_img.png";
import { debounce } from 'lodash';

import InstituteSlider from "../components/InstituteSlider";
import StudyAbroadSlider from "../components/StudyAbroadSlider";
import ExploreCoursesSlider from "../components/ExploreCoursesSlider";
import TeacherSlider from "../components/TeacherSlider";
import ExamSlider from "../components/ExamSlider";
import CollegeSlider from "../components/CollegesSlider";
import TopPlacesSlider from "../components/TopPlacesSlider";
import NewAndStorySlider from "../components/NewsStorySlider";
import CreatorSlider from "../components/CreatorSlider";
import no1 from "../assets/img/creator/no1.png";
import backgroundCreatorBg from "../assets/img/creator/application-bg.png";
// import ExamSlider from './ExamSlider';
// import creator1 from "../assets/img/creator/1.png";
// import creator2 from "../assets/img/creator/2.png";
// import creator3 from "../assets/img/creator/3.png";
// import creator4 from "../assets/img/creator/4.png";
// import creator5 from "../assets/img/creator/5.png";
// import creator6 from "../assets/img/creator/6.png";

// import ProductSlider from "../components/ProductSlider";
// import MathSlider from "../components/MathSlider";
import girlImage from "../assets/img/exam/banner-left-girl.png"
import boyImage from "../assets/img/exam/banner-right-boy.png"
import userImage from '../assets/img/exam/user_icn.png'
import userImage2 from '../assets/img/exam/user_icn2.png'
import userImage3 from '../assets/img/exam/user_icn3.png'
import userImage4 from '../assets/img/exam/user_icn4.png'
import readingBoyImage from '../assets/img/exam/reading-boy.png'
import carElementImage from '../assets/img/exam/cer_element.png'
import neetImage from '../assets/img/exam/neet.png'
import pdImage from '../assets/img/exam/pd.png'
import CourseTypeSlider from './CourseTypeSlider';
import WallOfFame from './WallOfFame';
import studentImage from '../assets/img/exam/student1.png'
import studentImage1 from '../assets/img/exam/student2.png'
import TestSeriesSection from './TestSeriesSection';
import SolvedQuestionsSection from './SolvedQuestionsSection';
import onlineTestImage from '../assets/img/exam/online-test.png'
import scoolerImage from '../assets/img/exam/scholor1.png'
import scoolerImage1 from '../assets/img/exam/scholor2.png'
import InstitutesSection from './InstitutesSection';
import TestimonialSlider from './TestimonialSlider';



const Home = () => {
  const [isModalOpen, setIsModalOpen] = useState(true);
  const navigate = useNavigate();
  const textRef = useRef(null);
  const [selectedExam, setSelectedExam] = useState(null);
  const [examData, setExamData] = useState([]);
  const [searchQuery, setSearchQuery] = useState(""); // State to store search input
  const [text, setText] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [query, setQuery] = useState('');
  const [searchTeachersResult, setSearchTeachersResult] = useState([]);
  const [searchCoursesResult, setSearchCoursesResult] = useState([]);
  const [searchUsersResult, setSearchUsersResult] = useState([]);
  const [searchPostsResult, setSearchPostsResult] = useState([]);
  const [annoucement, setAnnoucement] = useState([]);
  const [achivement, setAchivement] = useState([]);
  const [subscription,setSubscription] = useState([])
  const [class1, setClass1] = useState([]);



  useEffect(() => {
    fetchAnnoucement();
    fetchAchivement();
    fetchExamPreparation();
    fetchClass()
    fetchSubscription()
  }, []);


  useEffect(() => {
    if (selectedExam) {
      fetchExamFilterData(selectedExam)
    }

  }, [selectedExam]);



  const fetchClass = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL}/getClassName`, {
            headers: {
                "Authorization": `Bearer ${ACCESS_TOKEN_NAME()}`,
                "Content-Type": "application/json",
            },
        });
        setClass1(response.data);
    } catch (err) {
        console.error("Error fetching Exam Preparations:", err);
    }
};


  const fetchExamFilterData = async (title) => {
    try {
      const response = await axios.get(`${API_BASE_URL}/getExamPreparationsPaperfilter?title=${title}`, {
        headers: {
          "Authorization": `Bearer ${ACCESS_TOKEN_NAME()}`,
          "Content-Type": "application/json",
        },
      });

      console.log("data filter will be", response)
      if (response.data.length > 0) {
        setExamData(response.data);
      }else{
        setExamData([]);
      }
    } catch (err) {
      console.error("Error fetching announcement data:", err);
    }
  };



  const fetchAnnoucement = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/getAnnouncement`, {
        headers: {
          "Authorization": `Bearer ${ACCESS_TOKEN_NAME()}`,
          "Content-Type": "application/json",
        },
      });
      // console.log("annoucement data will be", response)
      setAnnoucement(response.data);
    } catch (err) {
      console.error("Error fetching announcements:", err);
    }
  };

  const fetchSubscription = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/getSubscriptionPlan`, {
        headers: {
          "Authorization": `Bearer ${ACCESS_TOKEN_NAME()}`,
          "Content-Type": "application/json",
        },
      });
      // console.log("annoucement data will be", response)
      setSubscription(response.data);
    } catch (err) {
      console.error("Error fetching announcements:", err);
    }
  };


  const fetchExamPreparation = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/getExamPreparationsPaper`, {
        headers: {
          "Authorization": `Bearer ${ACCESS_TOKEN_NAME()}`,
          "Content-Type": "application/json",
        },
      });
      // console.log("annoucement data will be", response)
      setExamData(response.data);
    } catch (err) {
      console.error("Error fetching announcements:", err);
    }
  };

  const fetchAchivement = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/getAchievement`, {
        headers: {
          "Authorization": `Bearer ${ACCESS_TOKEN_NAME()}`,
          "Content-Type": "application/json",
        },
      });
      console.log("achivement data will be", response)
      setAchivement(response.data);
    } catch (err) {
      console.error("Error fetching roles:", err);
    }
  };





  const teachers = [
    { id: 1, name: 'Physics Walla', image: teacher1 },
    { id: 2, name: 'Math Guru', image: teacher2 },
    { id: 3, name: 'Biology Expert', image: teacher3 },
    { id: 4, name: 'Chemistry Master', image: teacher4 },
  ];

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: ""
  });
  const [successMessage, setSuccessMessage] = useState(""); // State for success message
  const [errorMessage, setErrorMessage] = useState(""); // State for error message

  // Handle input change
  const handlesubsChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  // Handle form submission subscription form
  const handleSubmit = async (e) => {
    e.preventDefault(); // Prevent page reload
    setSuccessMessage(""); // Reset messages
    setErrorMessage("");

    try {
      const response = await axios.post(`${API_BASE_URL}/saveSubscriptionData`, formData, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      console.log("sub status", response.status);
      if (response.status === 201) {
        setSuccessMessage("Thank you for your Subscription!");
        setFormData({ name: "", email: "" }); // Reset form
      } else {
        setErrorMessage("Failed to subscription. Please try again.");
      }
    } catch (error) {
      console.error("Error:", error);
      setErrorMessage("Failed to submit subscription. Please try again.");
    }
  };

  // Open the modal on page load
  useEffect(() => {
    setIsModalOpen(true); // Automatically open the modal when the page loads
  }, []);

  const closeModal = () => {
    setIsModalOpen(false); // Close the modal
  };


  // Handle search input change
  const handleChange = (e) => {
    setQuery(e.target.value);
  };

  // Debounced search function to limit API calls
  const handleSearch = useCallback(
    debounce(async () => {
      if (!query.trim()) return;

      setLoading(true);
      setError('');

      try {
        const response = await axios.get(API_BASE_URL + `/mainSearch?query=${query}`);
        console.log("Search Teacher Results:", response.data.teachers);
        setSearchTeachersResult(response.data.teachers);
        setSearchCoursesResult(response.data.courses);
        setSearchUsersResult(response.data.users);
        setSearchPostsResult(response.data.posts);
      } catch (err) {
        setError('An error occurred while searching.');
      } finally {
        setLoading(false);
      }
    }, 500),
    [query]
  );

  const handleResultClick = (instituteId) => {
    navigate(`/InstituteDetail/${instituteId}`); // Navigate to the Institute detail page
  };

  const bannerPadhaiStyle1 = {
    backgroundImage: `url(${backgroundBanner1})`,
  };
  const bannerPadhaiStyle2 = {
    backgroundImage: `url(${backgroundBanner2})`,
  };
  const bannernoStyle1 = {
    backgroundImage: `url(${backgroundCreatorBg})`,
  };

  useEffect(() => {
    console.log("Updated searchResult:", searchUsersResult);
  }, [searchTeachersResult, searchCoursesResult, searchUsersResult, searchPostsResult]);

  useEffect(() => {
    if (textRef.current) {
      init(textRef.current, {
        strings: ["The Right EDUCATION"],
        loop: true,
      });
    }
  }, []);
  useEffect(() => {
    handleSearch();
  }, [query, handleSearch]);

  const lastAnnouncement = annoucement[annoucement.length - 1]?.announcement_name;


  return (
    <>
      {/* Hero Section */}
      <main class="">
        <div class="nws_scroll">



          <marquee behavior="scroll" scrollAmount="5" scrollDelay="5" direction="left">
            <span dangerouslySetInnerHTML={{ __html: lastAnnouncement }} />
          </marquee>


        </div>

        <section class="banner_padhai">
          <div class="banner_padhai1"></div>
          <div class="banner_padhai2"></div>
          <div class="hero-section">
            <div class="">
              <div class="hero-single orange_grndt">
                <div class="container">
                  <div class="row align-items-center">
                    <div class="col-md-12 col-lg-12 text-center">
                      <div class="hero-content">
                        <h1 class="most-title">
                          India’s <span class="theme2_color">Most Popular</span> Exam Preparation
                        </h1>
                        <p class="prepare_txt">
                          Prepare for Exams with Expert Concepts, Practice Questions and Up-To-Date Study Notes
                        </p>
                      </div>
                    </div>
                  </div>


                  <div class="text-center form-group srch_area mt-3 layer_up">
                    <input type="search" value={query}
                      onChange={handleChange}
                      name="search-field"
                      placeholder="Find Institute, Colleges, Courses, Exams"
                      required="" /><i class="far fa-search srch_glass"></i>
                    <button type="submit">Search</button>
                    {error && <p style={{ color: 'red' }}>{error}</p>}
                    <ul>
                      {/* {searchTeachersResult.length > 0 ? (
              searchTeachersResult.map((Teacher) => (
                <li key={Teacher.id} onClick={() => handleResultClick(Teacher.id)}>
                  {Teacher.name} - {Teacher.bio_info}
                </li>
              ))
            ) : (
              <p></p>  
            )} */}
                      {searchCoursesResult.length > 0 ? (
                        searchCoursesResult.map((Course) => (
                          <li key={Course.id} onClick={() => handleResultClick(Course.id)}>
                            {Course.course_title} - {"Course"}
                          </li>
                        ))
                      ) : (
                        <p></p>
                      )}
                      {searchUsersResult.length > 0 ? (
                        searchUsersResult.map((User) => (
                          <li key={User.id} onClick={() => handleResultClick(User.id)}>
                            {User.name} - {User.role_name}
                          </li>
                        ))
                      ) : (
                        <p></p>
                      )}
                      {searchPostsResult.length > 0 ? (
                        searchPostsResult.map((Post) => (
                          <li key={Post.id} onClick={() => handleResultClick(Post.id)}>
                            {Post.post_title} - {"Post"}
                          </li>
                        ))
                      ) : (
                        <p></p>
                      )}
                    </ul>
                  </div>

                  <p class="hub dark_color text-center pt-3">Your Ultimate Hub For <span class="theme2_color">Entrance Exam</span> Preparations</p>

                  <ul class="bnr_ftrs">

                    <li>Learn</li>
                    <li>Analyse</li>
                    <li>Practice</li>
                    <li>Improve</li>

                  </ul>
                  <div class="text-center start_btn pt-3"><a href="#" class="theme-btn"> Let’s Start</a></div>

                  <div class="banner_padhai1"></div>
                  <div class="banner_padhai2"></div>

                  <div class="banner_exm_lft"><img src={girlImage} /></div>
                  <div class="banner_exm_right"><img src={boyImage} /></div>

                </div>
              </div>

            </div>
          </div>

        </section>
        <section class="counter_pd pt-5">
          {/* <div class="container">
            <div class="counter_wrap">
              <div class="row">

                <div class="col-md-3 col-6">
                  <div class="user_bx_pd bg_use_pd">
                    <span class="use_icn_hold"><img src={userImage} /></span>
                    <div>
                      <p>Users</p>
                      <h5>4 Lakh</h5>
                    </div>

                  </div>
                </div>
                <div class="col-md-3 col-6">
                  <div class="user_bx_pd">
                    <span class="use_icn_hold exm_bg1"><img src={userImage2} /></span>
                    <div>
                      <p>Exams </p>
                      <h5>1792</h5>
                    </div>
                  </div>
                </div>
                <div class="col-md-3 col-6">
                  <div class="user_bx_pd">
                    <span class="use_icn_hold exm_bg2"><img src={userImage3} /></span>
                    <div>
                      <p>Test Attempted</p>
                      <h5>152071</h5>
                    </div>
                  </div>
                </div>
                <div class="col-md-3 col-6">
                  <div class="user_bx_pd">
                    <span class="use_icn_hold exm_bg3"><img src={userImage4} /></span>
                    <div>
                      <p> Selected</p>
                      <h5>82017</h5>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div> */}

          <div className="container">
            <div className="counter_wrap">
              <div className="row">
                {achivement.map((item, index) => (
                  <div className="col-md-3 col-6" key={item.id}>
                    <div className={`user_bx_pd ${index === 0 ? 'bg_use_pd' : ''}`}>
                      <span className={`use_icn_hold ${index === 1 ? 'exm_bg1' : index === 2 ? 'exm_bg2' : index === 3 ? 'exm_bg3' : ''}`}>
                        {item.media_image_path ? (
                          <img
                            src={`${Image_Base_Url}${item.media_image_path}`}
                            alt="Institute Lobo"

                          />
                        ) : (
                          "No Image"
                        )}
                      </span>
                      <div>
                        <b>{item.name}</b>
                        <td dangerouslySetInnerHTML={{ __html: item.description }} />
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>



        </section>

        <section class="selection_pd pt-5">

          <div class="container position-relative">
            <div class="read_boy"><img src={readingBoyImage} /></div>
            <div class="crcle_elm"><img src={carElementImage} /></div>

            <div class="selection_wrap prp_bg">
              <div class="row text-center">
                <p class="title_slc pb-2">Start Your Exam Preparations For Selections</p>
                <div class="text-center"><a href="#" class="theme-btn">FOR FREE</a> </div>
              </div>
            </div>
          </div>
        </section>


        <section class="bg_sec_all py-5">

          <div class="container">

            {/* <div class="coursetype-slider owl-carousel owl-theme">
    
                <div class="course_name_hold">
                    Enginneering
                </div>
                <div class="course_name_hold">
                    Medical
                </div>
    
                <div class="course_name_hold">
                    Fashion Designing
                </div>
    
                <div class="course_name_hold">
                    IELTS
                </div>
    
                <div class="course_name_hold">
                    GRE
                </div>
    
                <div class="course_name_hold">
                    GMAT
                </div>
    
                <div class="course_name_hold">
                    MBA
                </div>
    
            </div> */}


            <CourseTypeSlider onSelectType={(title) => setSelectedExam(title)} />
            <div class="row mt-5">
            {examData.slice(0, 6).map((item, idx) => (
               <div class="col-md-4 col-12 pb-3 pb-lg-0 pb-md-0"   onClick={() => navigate(`/examdetail/${item.id}`)}
               style={{ cursor: 'pointer' }}>
               <div class="course_inr_wrap bg_crse1">
                 <div class="exm_content_pd">
                   <div class="course-bottom-left">
                     <img src={`${Image_Base_Url}${item.media_image_path}`} alt="media_image_path" />
                     <span dangerouslySetInnerHTML={{ __html: item.description }} /> 
                   </div>
                   <div><a href="#"><i class="far fa-arrow-right"></i></a></div>
                 </div>
               </div>
             </div>
            ))}
            </div>
         

          </div>

        </section>

        <div class="container pt-4">
          <div class="row text-center">
            <div class="col-lg-12"><img src={pdImage} /></div>

          </div>
        </div>

        <div class="course-area py-4 explore_course">
          <div class="banner_padhai1"></div>
          <div class="banner_padhai2"></div>
          <div class="container">
            <div class="row">
              <div class="site-heading text-left">
                <h2 class="site-title">Explore Courses</h2>
              </div>
            </div>
            <ExploreCoursesSlider />
          </div>
        </div>


        <section class="wall_fame">


          <WallOfFame />
        </section>

        <section class="py-5">
          <div class="container">
            <div class="bookfree_bx">
              <div class="expert_right_img"><img src={studentImage} /></div>
              <div class="row">

                <p class="title_add">Book Free Counseling Session with Experts </p>
                <p class="title_add2">Enter your contact number to get a call back from our expert Counsellor’s</p>
              </div>

              <div class="row pt-3">
                <div class="col-md-4">
                  <div class="form-group">
                    <input type="text" class="form-control" name="name" placeholder="+91- 123 456 7890" required="" />
                  </div>
                </div>
                <div class="col-md-4 pt-3 pt-lg-0 pt-md-0"> <button type="submit" class="theme-btn">Book a Free Call <i class="far fa-paper-plane"></i></button></div>



              </div>
            </div>

          </div>



        </section>

        {/* most preffered slider */}
        <section class="test_series_pd pb-4">
          <TestSeriesSection />
        </section>

        <section class="spl_plans py-4 position-relative">
          <div class="student_right"><img src={studentImage1} /></div>
          <div class="container">
            <div class="row">
              <div class="spl_pln_bx_wrp">
              {subscription.map((plan) => (
                <div class="spl_pln_bx_one">
                  <p class="spl_text_orange">{plan.plan_title}</p>
                  <p class="dark_color">{plan.title}</p>
                  {/* <p class="spl_price">{plan.price}/-Rs</p> */}
                  <div className="d-flex">
  <p className="spl_price">{plan.price}/-</p>
  <div
    className="spl_price"
    dangerouslySetInnerHTML={{ __html: plan.description }}
  />
</div>


                </div>
                  ))}
                {/* <div class="spl_pln_bx_one">
                  <p class="spl_price">499/-Rs Yearly </p>
                  <p class="spl_text_orange">Subscription For Exam Preparation<br></br>(Mock Test)</p>
                </div> */}
              </div>
              <p class="login_txt dark_color pt-3">Login For Special Offers</p>
              <div class="tst_btn pt-2"><a href="#" class="theme-btn">Give Test</a></div>
            </div>
          </div>

        </section>

        <div>
          <SolvedQuestionsSection />
        </div>

        <section class="exam-simulating pb-4">
          <div class="container">
            <div class="row text-center">
              <p class="simulating pb-3 dark_color">Exam-simulating practice for</p>

              <div class="col-md-8 m-auto">
                <div class="sof_box">SOF LEVEL-2</div>
                <p class="mock-text dark_color py-2">with Padhai Dekho Mock Tests</p>
                <div class="mk_test_blw">
                  <div class="tst_mok_bx1 orange_bg">
                    <span class="wdth_mg_tst_bx mkst_bdr_rgt">I</span>
                    <span class="wdth_mg_tst_bx mkst_bdr_rgt">E</span>
                    <span class="wdth_mg_tst_bx">O</span>
                  </div>

                  <div class="tst_mok_bx1 ylw_bg">
                    <span class="wdth_mg_tst_bx mkst_bdr_rgt">I</span>
                    <span class="wdth_mg_tst_bx mkst_bdr_rgt">E</span>
                    <span class="wdth_mg_tst_bx">O</span>
                  </div>
                  <div class="tst_mok_bx1 drk-grn_bg">
                    <span class="wdth_mg_tst_bx mkst_bdr_rgt">I</span>
                    <span class="wdth_mg_tst_bx mkst_bdr_rgt">E</span>
                    <span class="wdth_mg_tst_bx">O</span>
                  </div>

                </div>
                <p class="mock-text dark_color py-2">FOE CLASSES 3-8</p>
                <img src={onlineTestImage} />
              </div>


            </div>
          </div>

        </section>



        <section class="scholorship green_grndt py-4 position-relative">
          <div class="scholor1"><img src={scoolerImage} /></div>
          <div class="container">
            <div class="row text-center">
              <p>Prepare Yourself for Science Olympiad. mock papers, also known as demo test papers, actually being the previous year's question
                papers. Below is a sample of the question paper for students to understand the pattern of the exam.</p>


              <div class="col-lg-8 m-auto pt-3">
              
              <div class="row justify-content-center">
                {class1.slice(0, 6).map((item, idx) => (
                 
                  <div class="col-md-2 col-4 p-0"><a href="#" class="theme-btn">{item.class_name}</a></div>
                
                ))}
                  </div>


              </div>
            </div>
            <div class="row pt-5">
              <p class="Scholorship_txt position-relative">Scholorship for students</p>
              <div class="scholor2"><img src={scoolerImage1} /></div>
            </div>
          </div>

        </section>

        <div class="event-area py-4">
          <div class="container">
            <div class="row">
              <Modal isOpen={isModalOpen} closeModal={closeModal}>
                <PdExam />
              </Modal>
              {/* <div class="col-lg-12">
                <div class="site-heading text-left">
                  <h2 class="site-title">Institute</h2>
                </div>
              </div> */}
            </div>
            {/* <InstituteSlider /> */}
            <InstitutesSection />
          </div>
        </div>
        <div class="event-area bg study-abroad py-4">
          <div class="container">
            <div class="row">
              <div class="col-lg-12">
                <div class="site-heading text-left">
                  <h2 class="site-title">Study Abroad</h2>
                </div>
              </div>
            </div>
            <StudyAbroadSlider />
          </div>
        </div>
        <div class="course-area py-4 explore_course">

          <section class="sec_bg">
            <div class="container">
              <div class="row">
                <div class="add-dvd">
                  <span class="add-norm">Calculate your<br />
                    <span class="add-bld">chances of Getting into a College</span>
                  </span>
                  <span>
                    <a href="" class="theme-btn mt-30" data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight" aria-controls="offcanvasRight">Learn More<i class="fas fa-arrow-right-long"></i></a>
                  </span>
                  <span><img src={addImg} /></span>
                </div>
              </div>
            </div>
          </section>
          <div class="event-area bg learn py-4">
            <div class="container">
              <div class="row">
                <div class="col-lg-12">
                  <div class="site-heading text-left">
                    <h2 class="site-title">Learn From The Best Teachers</h2>

                  </div>
                </div>
              </div>
              <TeacherSlider />
            </div>
          </div>
          <div class="course-area py-4 explore_course exams">
            <div class="container">
              <div class="row">
                <div class="site-heading text-left">
                  <h2 class="site-title"> Competitive Exams</h2>
                </div>
              </div>
              <ExamSlider />
            </div>
          </div>
          <div class="course-area py-4 explore_course exams universities bg">
            <div class="container">
              <div class="row">
                <div class="site-heading text-left">
                  <h2 class="site-title">Top Universities/Colleges/Schools</h2>
                </div>
              </div>
              <CollegeSlider />
            </div>
          </div>
          <div class="partner-area  pt-30 pb-40">
            <div class="container">
              <div class="row">
                <div class="site-heading text-left">
                  <h2 class="site-title">PadhaiDekho is trusted by India’s leading Professor and Creators</h2>
                </div>
              </div>
              <div class="creators_wrap">
                <CreatorSlider />
              </div>
            </div>
          </div>
          <div class="application_bg" style={bannernoStyle1}>
            <div class="container">
              <div class="award">
                <span><img src={no1} /></span>
                <p class="no-one">India’s Common Application Form Available on Padhaidekho.com</p>
              </div>
              <h2 class="application_bg-title pt-3">ComForm Common Application Form for <span class="college">2000+ Colleges/Universities</span></h2>
              <p class="click">Click to submit your Application for your Dream colleges</p>
              <button type="submit" class="theme-btn mt-3" data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight" aria-controls="offcanvasRight">Enquire Now
                <i class="far fa-paper-plane"></i></button>
            </div>
          </div>
          <div class="department-area bg py-4">
            <div class="container">
              <div class="row">
                <div class="col-lg-12">
                  <div class="site-heading text-left">
                    <h2 class="site-title">Explore Top Study Places</h2>
                  </div>
                </div>
              </div>
              <TopPlacesSlider />
            </div>
          </div>
          {/* <div class="blog-area py-4">
            <div class="container">
              <div class="row">
                <div class="col-lg-12">
                  <div class="site-heading text-left">
                    <h2 class="site-title">Latest Stories & News</h2>
                  </div>
                  <NewAndStorySlider />
                </div>
              </div>
            </div>
          </div> */}


          <div class="blog-area py-4">
            <div class="container">
              <div class="row">
                <div class="col-lg-12">
                  <div class="site-heading text-left">

                    <h2 class="site-title">What Our Students Say</h2>

                  </div>
                </div>
              </div>
              <div class="row">
                <TestimonialSlider />


              </div>

            </div>
          </div>

          {/* newsletter block */}
          <div class="explore-study-area bg py-4">
            <div class="container">
              <div class="row">
                <div class="col-lg-12">
                  <div class="site-heading text-left">
                    <h2 class="site-title">Subscribe to our news letter</h2>
                  </div>
                </div>
              </div>
              <div class="row contact-form">
                {successMessage && <div style={{ color: "green", marginBottom: "10px" }}>{successMessage}</div>}
                <form className="row subscription-form" onSubmit={handleSubmit}>
                  <div class="col-lg-9">
                    <div class="row">
                      <div class="col-md-6">
                        <div class="form-group">
                          <input type="text" class="form-control" name="name" value={formData.name} onChange={handlesubsChange} placeholder="Your Name" required="" />
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <input type="phone" class="form-control" name="phone" value={formData.phone} onChange={handlesubsChange} placeholder="Your Contact Number" required="" />
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <input type="email" class="form-control" name="email" value={formData.email} onChange={handlesubsChange} placeholder="Your Email" required="" />
                        </div>
                      </div>
                      {/* <div class="col-md-6">
                    <div class="form-group">
                      <select class="form-select form-control" id="course_tag" name="course_tag" aria-label="course_tag">
                        <option disabled="" value="">Choose your course</option>
                        <optgroup label="Popular Courses">
                          <option value="1">BE/B.Tech - Bachelors (Technology)</option>
                          <option value="2">MBA/PGDM - Masters (Business Administration)</option>
                          <option value="3">BBA/BBM - Bachelors (Business Administration)</option>
                          <option value="4">B.Com - Bachelors (Commerce)</option>
                          <option value="5">BA - Bachelors (Arts)</option>
                          <option value="6">MA - Masters (Arts)</option>
                          <option value="7">MBBS - Bachelors (Medicince and Surgery)</option>
                          <option value="8">BCA - Bachelors (Computer Applications)</option>
                          <option value="9">MCA - Masters (Computer Applications)</option>
                          <option value="10">ME/M.Tech - Masters (Technology)</option>
                          <option value="11">B.Sc - Bachelors (Science)</option>
                          <option value="12">M.Sc - Masters (Science)</option>
                        </optgroup>
                        <optgroup label="Bachelor">
                          <option value="13">B.Arch - Bachelor (Architecture)</option>
                          <option value="14">BVSc - Bachelor (Veterinary Sciences)</option>
                          <option value="15">Bachelor of Animation - Bachelor (Animation)</option>
                          <option value="16">BSW - Bachelor (Arts)</option>
                          <option value="17">LLB - Bachelor (Law)</option>
                          <option value="18">BPH - Bachelor (Medical)</option>
                          <option value="19">B.F.Sc - Bachelor (Science)</option>
                          <option value="20">Bachelors (Animation &amp; Graphic Design) - Bachelor (Arts)</option>
                          <option value="21">B.P.Ed - Bachelor (Education)</option>
                          <option value="22">BFA - Bachelor (Arts)</option>
                          <option value="23">BUMS - Bachelor (Medical)</option>
                          <option value="24">Bachelor of Physiotherapy(BPT) - Bachelor (Medical)</option>
                          <option value="25">B.Planning - Bachelor (Architecture)</option>
                          <option value="26">BHMS - Bachelor (Medical)</option>
                          <option value="27">BBA (Aviation) - Bachelor (Aviation)</option>
                          <option value="28">MBBS - Bachelors (Medicince and Surgery)</option>
                          <option value="29">BMM - Bachelor (Mass Communications)</option>
                          <option value="30">BHM - Bachelor (Hotel Management)</option>
                          <option value="31">B.Com - Bachelors (Commerce)</option>
                          <option value="32">B.Des - Bachelor (Design)</option>
                          <option value="33">B.Ed - Bachelor (Education)</option>
                          <option value="34">B.Pharm - Bachelor (Pharmacy)</option>
                          <option value="35">B.Sc - Bachelors (Science)</option>
                          <option value="36">B.Sc (Agriculture) - Bachelor (Agriculture)</option>
                          <option value="37">B.Sc (Medicine) - Bachelor (Medical)</option>
                          <option value="38">B.Sc (Nursing) - Bachelor (Paramedical)</option>
                          <option value="39">BA - Bachelors (Arts)</option>
                          <option value="40">Bachelors in Vocational Courses - Bachelor (Vocational Courses)</option>
                          <option value="41">BAMS - Bachelor (Medical)</option>
                          <option value="42">BBA/BBM - Bachelors (Business Administration)</option>
                          <option value="43">BCA - Bachelors (Computer Applications)</option>
                          <option value="44">BE/B.Tech - Bachelors (Technology)</option>
                          <option value="45">BDS - Bachelor (Dental)</option>
                        </optgroup>
                        <optgroup label="Doctorate">
                          <option value="46">M.Phil/Ph.D in Paramedical - Doctorate (Paramedical)</option>
                          <option value="47">M.Phil/Ph.D in Medicine - Doctorate (Medical)</option>
                          <option value="48">M.Phil/Ph.D in Pharmacy - Doctorate (Pharmacy)</option>
                          <option value="49">M.Phil/Ph.D in Science - Doctorate (Science)</option>
                          <option value="50">MD - Doctorate (Medical)</option>
                          <option value="51">Ph.D in Veterinary Science - Doctorate (Veterinary Sciences)</option>
                          <option value="52">M.Phil/Ph.D in Mass Communication - Doctorate (Mass Communications)</option>
                          <option value="53">M.Phil/Ph.D in Management - Doctorate (Management)</option>
                          <option value="54">M.Phil/Ph.D in Law - Doctorate (Law)</option>
                          <option value="55">M.Phil/Ph.D in Architecture - Doctorate (Architecture)</option>
                          <option value="56">M.Phil/Ph.D in Arts - Doctorate (Arts)</option>
                          <option value="57">M.Phil/Ph.D in Commerce - Doctorate (Commerce)</option>
                          <option value="58">M.Phil/Ph.D in Computer Applications - Doctorate (Computer Applications)</option>
                          <option value="59">M.Phil/Ph.D in Dental - Doctorate (Dental)</option>
                          <option value="60">M.Phil/Ph.D in Agriculture - Doctorate (Agriculture)</option>
                          <option value="61">M.Phil/Ph.D in Design - Doctorate (Design)</option>
                          <option value="62">M.Phil/Ph.D in Hotel Management - Doctorate (Hotel Management)</option>
                          <option value="63">M.Phil/Ph.D in Engineering - Doctorate (Engineering)</option>
                          <option value="64">M.Phil/Ph.D in Education - Doctorate (Education)</option>
                          <option value="65">D.Litt - Doctorate (Arts)</option>
                        </optgroup>
                        <optgroup label="Masters">
                          <option value="66">M.Des - Masters (Design)</option>
                          <option value="67">M.P.Ed - Masters (Education)</option>
                          <option value="68">MHA - Masters (Management)</option>
                          <option value="69">M.Ed - Masters (Education)</option>
                          <option value="70">M.Com - Masters (Commerce)</option>
                          <option value="71">Executive MBA - Masters (Management)</option>
                          <option value="72">MVSc - Masters (Veterinary Sciences)</option>
                          <option value="73">Master of Animation - Masters (Animation)</option>
                          <option value="74">M.Ch - Masters (Medical)</option>
                          <option value="75">M.Arch - Masters (Architecture)</option>
                          <option value="76">M.F.Sc - Masters (Science)</option>
                          <option value="77">MPH - Masters (Medical)</option>
                          <option value="78">LLM - Masters (Law)</option>
                          <option value="79">MSW - Masters (Arts)</option>
                          <option value="80">MMS - Masters (Management)</option>
                          <option value="81">M.Pharm - Masters (Pharmacy)</option>
                          <option value="82">MS - Masters (Medical)</option>
                          <option value="83">M.Sc - Masters (Science)</option>
                          <option value="84">M.Sc (Agriculture) - Masters (Agriculture)</option>
                          <option value="85">M.Sc (Aviation) - Masters (Aviation)</option>
                          <option value="86">M.Sc (Medicine) - Masters (Medical)</option>
                          <option value="87">M.Sc (Nursing) - Masters (Paramedical)</option>
                          <option value="88">MA - Masters (Arts)</option>
                          <option value="89">Master of Physiotherapy(MPT) - Masters (Medical)</option>
                          <option value="90">Masters in Vocational Courses - Masters (Vocational Courses)</option>
                          <option value="91">MBA/PGDM - Masters (Business Administration)</option>
                          <option value="92">MCA - Masters (Computer Applications)</option>
                          <option value="93">MDS - Masters (Dental)</option>
                          <option value="94">ME/M.Tech - Masters (Technology)</option>
                          <option value="95">MHM - Masters (Hotel Management)</option>
                          <option value="96">MMC - Masters (Mass Communications)</option>
                          <option value="97">M.Planning - Masters (Architecture)</option>
                          <option value="98">Any Others Courses</option>
                        </optgroup>
                      </select>
                    </div>
                  </div> */}
                      <div class="form-group">
                        <textarea name="message" cols="30" rows="5" class="form-control" placeholder="Write Your Message"></textarea>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-3 d-flex align-items-center"><button type="submit" class="theme-btn">Send Message <i class="far fa-paper-plane"></i></button></div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default Home;